import { useState } from "react";
import { useClerk } from "@clerk/react";
import { LockKeyhole } from "lucide-react";
import { toast } from "sonner";
import { useApi, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { OtpField } from "./OtpField";

export default function TwoFAVerify({ email, onDone }) {
  const api = useApi();
  const { signOut } = useClerk();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const verify = async (value = code) => {
    if (value.length !== 6 || busy) return;
    setBusy(true);
    try {
      const { data } = await api.post("/auth/2fa/verify", { code: value });
      onDone(data.token);
    } catch (e) {
      toast.error(errMsg(e));
      setCode("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen" data-testid="twofa-verify-screen">
      <div className="card w-full max-w-md fade-up">
        <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-500/10 text-emerald-400">
          <LockKeyhole size={22} />
        </div>
        <h1 className="font-heading text-3xl font-extrabold">Verificação em duas etapas</h1>
        <p className="mt-2 text-sm text-slate-400">Abra o Google Authenticator e digite o código de 6 dígitos para {email}.</p>
        <div className="mt-6 space-y-4">
          <OtpField value={code} onChange={setCode} onComplete={verify} />
          <Button className="btn-primary w-full" disabled={busy || code.length !== 6} onClick={() => verify()} data-testid="verify-2fa-button">
            {busy ? "Verificando..." : "Entrar no painel"}
          </Button>
          <button className="w-full text-xs text-slate-500 hover:text-slate-300" onClick={() => signOut()} data-testid="twofa-signout-link">
            Sair desta conta
          </button>
        </div>
        <p className="mt-6 text-xs text-slate-500">5 códigos errados bloqueiam o acesso por 15 minutos.</p>
      </div>
    </div>
  );
}
